import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const RemoteControlLive = lazy(async () => {
  const m = await import("@/features/fleet/components/remote-control-live");
  return { default: m.RemoteControlLive };
});

export const fleetRemoteRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/fleet/remote",
  component: () => (
    <Suspense fallback={null}>
      <RemoteControlLive />
    </Suspense>
  ),
});
